module.exports = __webpack_public_path__ + "static/media/26_blanco.8cd0d5b1.svg";